const uploadRepo = (fileService) => {
    const uploadSingle = async ({name, file, type}) => await fileService.uploadSingle({
        name,
        file,
        type,
    })

    const uploadMultiple = (files) => fileService.uploadMultiple(files)

    return {
        uploadSingle,
        uploadMultiple,
    }
}

export default uploadRepo
